import React from 'react';
import { StatusType } from '@/utils/collaborator-status';

interface UpdateStatusCellProps {
    status?: StatusType | string;
}

const statusConfig = {
    PENDING: {
        label: 'Pendente',
        className: 'bg-red-100 text-red-800'
    },
    IN_PROGRESS: {
        label: 'Em andamento',
        className: 'bg-yellow-100 text-yellow-800'
    },
    UPDATED: {
        label: 'Atualizado',
        className: 'bg-green-100 text-green-800'
    }
};

const UpdateStatusCell: React.FC<UpdateStatusCellProps> = ({ status }) => {
    const currentStatus = (status || 'PENDING') as StatusType;
    const config = statusConfig[currentStatus] || statusConfig.PENDING;

    return (
        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${config.className}`}>
            {config.label}
        </span>
    );
};

export default UpdateStatusCell; 